module.exports = __webpack_public_path__ + "static/img/introduce-img2.41230689.png";